import {
  SET_USERS,
  SET_TOKENS,
  LOGOUT,
  UPDATE_BALANCE,
} from "../actions/constants";
import isEmpty from "../validations/is-empty";

const initialState = {
  isAuthenticated: false,
  user: {},
  balance: 0,
  token: localStorage.getItem("token"),
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USERS: {
      const { balance, ...user } = action.payload || {};
      return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        user,
        balance: Number.isFinite(Number(balance)) ? Number(balance) : 0,
      };
    }
    case SET_TOKENS:
      return {
        ...state,
        token: action.payload,
      };
    case UPDATE_BALANCE:
      return {
        ...state,
        // Keep the user reference stable so balance changes do not retrigger
        // page effects that depend on the user object.
        balance: Number.isFinite(Number(action.payload))
          ? Math.max(0, Number(action.payload))
          : state.balance,
      };
    case LOGOUT:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
        balance: 0,
      };
    default:
      return state;
  }
}
